// extracted by mini-css-extract-plugin
export default {"link":"Navbar_link__uvQox"};